import React from 'react';

export const IqviaLogoDark = (props) => (
  <svg
    width="136"
    height="24"
    viewBox="0 0 136 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <g>
        <g>
          <path
            d="M126.95 17.6967H120.629C119.905 17.6967 119.312 17.1074 119.312 16.3871C119.312 15.6667 119.905 15.0774 120.629 15.0774H126.983C127.707 15.0774 128.299 15.6667 128.299 16.3871C128.299 17.1074 127.707 17.6967 126.95 17.6967Z"
            fill="white"
          />
          <path
            d="M134.093 22.1168C133.632 22.1168 133.171 21.8549 132.941 21.4292L123.855 4.17433L114.605 21.4292C114.275 22.0513 113.452 22.3133 112.827 21.9531C112.202 21.6257 111.938 20.8071 112.3 20.185L122.736 0.736444C122.966 0.310801 123.427 0.0161257 123.888 0.0488675C124.382 0.0488675 124.81 0.310801 125.04 0.736444L135.278 20.185C135.608 20.8399 135.377 21.6257 134.719 21.9531C134.521 22.0513 134.291 22.1168 134.093 22.1168Z"
            fill="white"
          />
        </g>
        <path
          d="M103.971 22.1168C103.247 22.1168 102.655 21.5274 102.655 20.8071V1.3585C102.655 0.638179 103.247 0.0488281 103.971 0.0488281C104.696 0.0488281 105.288 0.638179 105.288 1.3585V20.8071C105.288 21.5274 104.696 22.1168 103.971 22.1168Z"
          fill="white"
        />
        <path
          d="M85.207 22.1169C84.7132 22.1169 84.2523 21.855 84.0548 21.4293L73.8167 1.98072C73.4875 1.32588 73.718 0.540082 74.3764 0.212664C75.0348 -0.114753 75.8249 0.114439 76.154 0.769274L85.2399 18.0242L94.4904 0.769274C94.8196 0.147181 95.6426 -0.114753 96.2681 0.245406C96.8935 0.572823 97.1569 1.39137 96.7948 2.01346L86.3592 21.4621C86.1288 21.855 85.6679 22.1169 85.207 22.1169Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M48.0076 11.6721C47.6784 5.54943 52.4189 0.343491 58.542 0.0160734C64.698 -0.311344 69.9652 4.40347 70.2285 10.4934C70.4589 14.7826 68.1875 18.6461 64.698 20.6761L65.4551 22.084C65.7843 22.7388 65.5539 23.5246 64.8955 23.8521C64.2371 24.1795 63.447 23.9503 63.1178 23.2954L62.2948 21.7238C61.4718 21.953 60.6159 22.1167 59.7271 22.1495C53.5711 22.4769 48.3368 17.7621 48.0076 11.6721ZM62.5581 16.5508L63.5128 18.3515C66.1134 16.7799 67.8253 13.8659 67.6607 10.6245C67.3973 5.94243 63.3811 2.37358 58.7065 2.60277C53.9989 2.86471 50.4107 6.8592 50.6411 11.5085C50.9045 16.1906 54.9207 19.7594 59.5953 19.5302C60.0891 19.4975 60.5829 19.432 61.0438 19.3338L60.2208 17.7622C59.8916 17.1074 60.122 16.3216 60.7804 15.9941C61.4388 15.6667 62.2289 15.8959 62.5581 16.5508Z"
          fill="white"
        />
        <path
          d="M41.4237 22.1168C40.6995 22.1168 40.1069 21.5274 40.1069 20.8071V1.3585C40.1069 0.638179 40.6995 0.0488281 41.4237 0.0488281C42.148 0.0488281 42.7405 0.638179 42.7405 1.3585V20.8071C42.7405 21.5274 42.148 22.1168 41.4237 22.1168Z"
          fill="white"
        />
      </g>
      <g>
        <path
          d="M23.9207 19.1929H7.56608C6.94142 19.1929 6.427 19.6963 6.427 20.315C6.427 20.9336 6.93808 21.4371 7.56608 21.4371H23.9207C24.5454 21.4371 25.0598 20.9336 25.0598 20.315C25.0598 19.6963 24.5487 19.1929 23.9207 19.1929Z"
          fill="white"
        />
        <path
          d="M27.8456 21.4337C27.221 21.4337 26.7065 20.9302 26.7065 20.3116C26.7065 19.6929 27.2176 19.1895 27.8456 19.1895H32.5923C33.217 19.1895 33.7314 19.6929 33.7314 20.3116C33.7314 20.9302 33.2203 21.4337 32.5923 21.4337H27.8456Z"
          fill="white"
        />
        <path
          d="M30.0671 17.1624C29.4424 17.1624 28.928 16.659 28.928 16.0403C28.928 15.4217 29.4391 14.9182 30.0671 14.9182H32.5924C33.2171 14.9182 33.7315 15.4217 33.7315 16.0403C33.7315 16.659 33.2204 17.1624 32.5924 17.1624H30.0671Z"
          fill="white"
        />
        <path
          d="M30.705 12.8912C30.0803 12.8912 29.5659 12.3877 29.5659 11.7691C29.5659 11.1537 30.077 10.647 30.705 10.647H32.5923C33.217 10.647 33.7314 11.1504 33.7314 11.7691C33.7314 12.3877 33.2203 12.8912 32.5923 12.8912H30.705Z"
          fill="white"
        />
        <path
          d="M30.1069 8.61995C29.4822 8.61995 28.9678 8.11648 28.9678 7.49784C28.9678 6.8792 29.4789 6.37573 30.1069 6.37573H32.5921C33.2168 6.37573 33.7312 6.8792 33.7312 7.49784C33.7312 8.11648 33.2201 8.61995 32.5921 8.61995H30.1069Z"
          fill="white"
        />
        <path
          d="M27.9457 4.34871C27.3211 4.34871 26.8066 3.84524 26.8066 3.2266C26.8066 2.60796 27.3177 2.10449 27.9457 2.10449H32.5922C33.2169 2.10449 33.7313 2.60796 33.7313 3.2266C33.7313 3.84524 33.2202 4.34871 32.5922 4.34871H27.9457Z"
          fill="white"
        />
        <path
          d="M26.142 14.9216H4.36588C3.74123 14.9216 3.22681 15.4251 3.22681 16.0437C3.22681 16.6624 3.73789 17.1658 4.36588 17.1658H26.142C26.7666 17.1658 27.2811 16.6624 27.2811 16.0437C27.2811 15.4251 26.77 14.9216 26.142 14.9216Z"
          fill="white"
        />
        <path
          d="M26.78 10.6501H1.13908C0.514422 10.6501 0 11.1536 0 11.7723C0 12.3909 0.511082 12.8944 1.13908 12.8944H26.78C27.4047 12.8944 27.9191 12.3909 27.9191 11.7723C27.9191 11.1536 27.408 10.6501 26.78 10.6501Z"
          fill="white"
        />
        <path
          d="M26.182 6.37915H2.75236C2.1277 6.37915 1.61328 6.88262 1.61328 7.50126C1.61328 8.1199 2.12436 8.62336 2.75236 8.62336H26.182C26.8066 8.62336 27.321 8.1199 27.321 7.50126C27.321 6.88262 26.81 6.37915 26.182 6.37915Z"
          fill="white"
        />
        <path
          d="M24.0208 2.10767H10.9899C10.3653 2.10767 9.85083 2.61113 9.85083 3.22977C9.85083 3.84841 10.3619 4.35188 10.9899 4.35188H24.0208C24.6455 4.35188 25.1599 3.84841 25.1599 3.22977C25.1599 2.61113 24.6488 2.10767 24.0208 2.10767Z"
          fill="white"
        />
      </g>
    </g>
  </svg>
);

export default IqviaLogoDark;
